export const EMPTY_MODEL = {
    model: '',
    definition: {},
};
export const EMPTY_MODEL_WES_WGS = {
    definition: {},
    model: {
        name: '',
        nameWithSubscript: '',
        description: '',
    },
};
